const normalize = (value) =>
	String(value || '')
		.trim()
		.toLowerCase()
		.replace(/\./g, '')
		.replace(/\s+/g, ' ');

const CANADA = {
	alberta: 'AB',
	'british columbia': 'BC',
	manitoba: 'MB',
	'new brunswick': 'NB',
	'newfoundland and labrador': 'NL',
	newfoundland: 'NL',
	'labrador': 'NL',
	'nova scotia': 'NS',
	'northwest territories': 'NT',
	nunavut: 'NU',
	ontario: 'ON',
	'prince edward island': 'PE',
	quebec: 'QC',
	saskatchewan: 'SK',
	yukon: 'YT',
};

const US = {
	alabama: 'AL',
	alaska: 'AK',
	arizona: 'AZ',
	arkansas: 'AR',
	california: 'CA',
	colorado: 'CO',
	connecticut: 'CT',
	delaware: 'DE',
	florida: 'FL',
	georgia: 'GA',
	hawaii: 'HI',
	idaho: 'ID',
	illinois: 'IL',
	indiana: 'IN',
	iowa: 'IA',
	kansas: 'KS',
	kentucky: 'KY',
	louisiana: 'LA',
	maine: 'ME',
	maryland: 'MD',
	massachusetts: 'MA',
	michigan: 'MI',
	minnesota: 'MN',
	mississippi: 'MS',
	missouri: 'MO',
	montana: 'MT',
	nebraska: 'NE',
	nevada: 'NV',
	'new hampshire': 'NH',
	'new jersey': 'NJ',
	'new mexico': 'NM',
	'new york': 'NY',
	'north carolina': 'NC',
	'north dakota': 'ND',
	ohio: 'OH',
	oklahoma: 'OK',
	oregon: 'OR',
	pennsylvania: 'PA',
	'rhode island': 'RI',
	'south carolina': 'SC',
	'south dakota': 'SD',
	tennessee: 'TN',
	texas: 'TX',
	utah: 'UT',
	vermont: 'VT',
	virginia: 'VA',
	washington: 'WA',
	'west virginia': 'WV',
	wisconsin: 'WI',
	wyoming: 'WY',
	'district of columbia': 'DC',
};

/**
 * Displays a region as a 2-letter abbreviation when possible.
 * Examples: "Alberta" -> "AB", "California" -> "CA", "MB" -> "MB"
 */
export default function toRegionAbbrev(region) {
	if (!region) return '';
	const raw = String(region).trim();
	const upper = raw.toUpperCase();

	// already abbreviated
	if (/^[A-Z]{2}$/.test(upper)) return upper;

	const key = normalize(raw);
	return CANADA[key] || US[key] || raw;
}




// WEBPACK FOOTER //
// ./src/utils/toRegionAbbrev.js